import {styled, useTheme} from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import React, {useCallback, useEffect, useRef, useState} from "react";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {useDispatch, useSelector} from "react-redux";
import {setLeftDrawer} from "../../Modules/Common/App";
import {AccountMenu} from "../Menu/AccountMenu";
import {NotificationMenu} from "../Menu/NotificationMenu";
import {Stack} from "@mui/material";
import { useSettings } from "../../Hooks/useSettings";

export const AppBarOffice = () => {

    const theme = useTheme();
    const dispatch = useDispatch();
    const config = useSelector((store) => store.app);
    const {getSettingValue} = useSettings();
    const open = config.leftDrawer.open;
    const drawerWidth = config.leftDrawer.width;
    const [, setCurrentMetrics] = useState();

    const StyledAppBar = styled(MuiAppBar, {

        shouldForwardProp: (prop) => prop !== 'open',
        })(({ theme, open }) => ({
        background: theme.appBar?.backgroundColor,
        zIndex: theme.zIndex?.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        }),
    }));

    const appBarRef = useRef(null)

    const metrics = useCallback(() => {
        const width = window.innerWidth;
        if (width < theme.breakpoints.values.sm) {
            return 'xs';
        } else if (width < theme.breakpoints.values.md) {
            return 'sm';
        } else if (width < theme.breakpoints.values.lg) {
            return 'md';
        } else if (width < theme.breakpoints.values.xl) {
            return 'lg';
        } else {
            return 'xl';
        }
    }, [theme.breakpoints.values]);


    useEffect(() => {
        const handleResize = () => {
            setCurrentMetrics(metrics());
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [metrics, setCurrentMetrics]);

    return (
        <StyledAppBar position="fixed" open={open} ref={appBarRef}>
            <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={ () => dispatch(setLeftDrawer({open:true}))}
                    edge="start"
                    sx={{
                        marginRight: 5,
                        ...(open && { display: 'none' }),
                    }}
                >
                    <MenuIcon />
                </IconButton>
                <Typography variant="h6" noWrap component="div">
                    { 'Roster Management'}
                </Typography>

                <Box sx={{ flexGrow: 1 }} />
                <Box sx={{ display: { md: 'flex' } }}>
                    <Stack direction={"row"} spacing={1}>
                        {getSettingValue('core.notification.enabled') && <NotificationMenu />}
                        <AccountMenu />
                    </Stack>
                </Box>
            </Toolbar>
        </StyledAppBar>
    )
}